<template>
  <b-container fluid :key="componentKey">
    <b-row>
      <b-col md="6" class="my-1">
        <b-alert v-if="success" show="" variant="success">Actualizado</b-alert>
        <b-form class="mb-4" v-on:submit.prevent>
          <b-form-group label-for="name" label="Nombre(s)" :valid-feedback="validUserNameFeedback(name)">
            <b-form-input id="name" placeholder="Nombre(s)" v-model="name" trim :state="validateUserName(name)"></b-form-input>
            <small class="text-danger" v-if="!isLetter(name)">Campo requerido. No debe estar vacío, el campo no debe contener caracteres numéricos ni especiales</small>
          </b-form-group>
          <b-form-group label-for="lastName" label="Apellidos"  :valid-feedback="validLastNameFeedback(lastName)">
            <b-form-input id="lastName" placeholder="Apellidos" v-model="lastName" :state="validateLastName(lastName)"></b-form-input>
            <small class="text-danger" v-if="!isLetter(lastName)">Campo requerido. No debe estar vacío, el campo no debe contener caracteres numéricos ni especiales</small>
          </b-form-group>
          <b-form-group label-for="email" label="Correo electrónico">
            <b-form-input id="email" placeholder="Correo electrónico" disabled v-model="email"></b-form-input>
          </b-form-group>
          <b-form-group label-for="phone" label="Número de teléfono" :invalid-feedback="validPhoneFeedback(telefono)" :valid-feedback="validPhoneFeedback(telefono)">
            <b-form-input id="phone" placeholder="Número de teléfono" v-model="telefono" trim :state="validatePhone(telefono)"></b-form-input>
            <small class="text-danger" v-if="!validateRegisteredPhone(telefono)">Este número de teléfono ya ha sido registrado previamente. Intenta con uno diferente.</small>
          </b-form-group>
          <b-form-group label-for="role" label="Rol">
            <b-form-select id="rol" v-model="selected" :options="options"></b-form-select>
          </b-form-group>
          <b-button
            size="large"
            class="text-center w-100"
            variant="secondary"
            :disabled="!validateForm()"
            @click="updateUser">
            <strong>Actualizar</strong>
          </b-button>
        </b-form>
      </b-col>
    </b-row>
    <!--
    <b-button @click="updateUserAttributes()">
      update
    </b-button>-->
  </b-container>
</template>
<script>
import gql from 'graphql-tag'
import * as firebase from 'firebase/app'
// import { updateUserAttributes } from '../../../cognito/adminQueries'
// import updateUserAttributes from '@/cognito/adminUpdateUser'
// import { encrypt } from '@/config/headers'
import headers from '@/config/headers.js'
const UPDATE_USER = gql`
    mutation updateUser($id: Int! $email: String, $name: String, $userName: String, $lastName: String, $phoneNumber: String, $roleId: Int, $roleName: String){
      updateUser(id: $id, useer: {email: $email name: $name lastName: $lastName userName: $userName phoneNumber: $phoneNumber roleId: $roleId}, roleName: $roleName){
        id
        email
        name
        userName
        role{
          id
          name
        }
      }
    }`
const UPDATE_USER_COGNITO_ATTRIBUTES = gql`
  mutation updateAdminUserAttributes($username: String, $phone: String, $role: String){
    updateAdminUserAttributes(username: $username, phone: $phone, role: $role){
      message
    }
  }
`
const USERS_QUERY = gql`
  query getUsers{
    getUsers{
      id
      email
      phoneNumber
    }
  }
`
export default {
  name: 'User',
  data() {
    return {
      getUserById: {},
      id: null,
      email: '',
      name: '',
      lastName: '',
      userName: '',
      telefono: '',
      active: '',
      role: {},
      options: [],
      selected: null,
      success: '',
      componentKey: 0,
      registeredUsersEmail: [],
      registeredUsersPhone: [],
    }
  },
  methods: {
    updateUser() {
      this.$apollo.mutate({
        mutation: UPDATE_USER,
        variables: {
          id: this.id,
          name: this.name,
          email: this.email,
          lastName: this.lastName,
          phoneNumber: '+521' + this.telefono,
          userName: this.userName,
          roleId: this.selected.id,
          roleName: this.selected.name,
        },
        context: headers(),
      })
        .then(data => {
          firebase.firestore().collection('adminSession').doc(this.email).delete()
            .then(result => {
              this.success = 'Actualizado'
              this.$router.push('/admin/administradores')
              this.success = ''
            })
            .catch(err => {
              console.log(err)
            })
          /*
          updateUserAttributes(this.email, '+521' + this.telefono, this.selected.name)
            .then(data => {
              this.success = 'Actualizado'
              setTimeout(() => {
                this.$router.push('/admin/administradores')
                this.success = ''
              }, 1000)
            })
            .catch(error => {
              console.log(error)
            })  */
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateUserAttributes() {
      this.$apollo.mutate({
        mutation: UPDATE_USER_COGNITO_ATTRIBUTES,
        variables: {
          username: this.email,
          phone: '+521' + this.telefono,
          role: this.selected.name,
        },
        context: {},
      })
        .then(data => {
          this.success = 'Actualizado'
          setTimeout(() => {
            this.$router.push('/admin/administradores')
            this.success = ''
          }, 1000)
        })
        .catch(error => {
          console.log(error)
        })
    },
    validateRegisteredPhone(telefono) {
      // console.log(this.registeredUsersPhone)
      if (this.registeredUsersPhone['+521' + telefono]) {
        return false
      } else {
        return true
      }
    },
    validateUserName(username) {
      return !(username === '') && this.isLetter(username)
    },
    validUserNameFeedback(username) {
      return this.validateUserName(username) === true ? 'El nombre(s) es válido.' : ''
    },
    validateLastName(lastName) {
      return !(lastName === '') && this.isLetter(lastName)
    },
    validLastNameFeedback(lastName) {
      return this.validateLastName(lastName) === true ? 'Los apellidos son válidos' : ''
    },
    validatePhone(phone) {
      // eslint-disable-next-line no-useless-escape
      var re = /^(1\s|1|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/
      return phone ? re.test(phone) : null
    },
    validPhoneFeedback(phone) {
      return this.validatePhone(phone) === true && this.validateRegisteredPhone(phone) ? 'El número de teléfono es válido.' : ''
    },
    isLetter(text) {
      // console.log(text)
      var re = /^[A-Za-z\u00C0-\u017F\s]+$/
      // console.log(re.test(text))
      return re.test(text)
    },
    validateForm() {
      // console.log(this.validateUserName(this.name) && this.validateUserName(this.lastName) && this.validatePhone(this.telefono) && this.selected && this.email)
      return this.validateUserName(this.name) && this.validateUserName(this.lastName) && this.validatePhone(this.telefono) && this.selected && this.email && this.validateRegisteredPhone(this.telefono) && this.isLetter(this.name) && this.isLetter(this.lastName)
    },
  },
  apollo: {
    getUserById: {
      query: gql`
        query getUserById($id: Int!){
          getUserById(id: $id){
            id
            email
            name
            userName
            lastName
            phoneNumber
            active
            role{
              name
              id
            }
          }
        }`,
      context: headers(),
      variables() {
        return {
          id: parseInt(this.$route.params.id),
        }
      },
      result({ data }) {
        // console.log(data)
        this.id = data.getUserById.id
        this.email = data.getUserById.email
        this.name = data.getUserById.name
        this.userName = data.getUserById.userName
        this.lastName = data.getUserById.lastName
        this.telefono = data.getUserById.phoneNumber
        this.active = data.getUserById.active
        this.role = data.getUserById.role
        this.telefono = this.telefono.replace('+521', '')
        this.telefono = this.telefono.replace('+52', '')
        this.selected = this.role
        // { this.id, this.email, this.name, this.userName, this.telefono, this.active, this.role } = data
        this.$apollo.query({ query: USERS_QUERY, context: headers() /*, context: { headers: encrypt(new Date().getTime()) } */ })
          .then(({ data }) => {
            // console.log(data)
            data.getUsers.forEach(user => {
              this.registeredUsersEmail[user.email] = 1
              this.registeredUsersPhone[user.phoneNumber] = 1
            })
            // console.log(this.registeredUsersPhone)
            delete this.registeredUsersEmail[this.email]
            delete this.registeredUsersPhone['+521' + this.telefono]

            // console.log('Registered Users')
            // console.log(this.registeredUsersEmail)
            // console.log(this.registeredUsersPhone)
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
    getAllRoles: {
      query: gql`
        query{
          getAllRoles{
            id
            name
          }
        }
      `,
      context: headers(),
      result({ data }) {
        this.options = []
        // console.log(encrypt(new Date().getTime()))
        // console.log(data)
        data.getAllRoles.forEach(role => {
          this.options.push({ value: role, text: role.name })
        })
        // console.log(this.options)
      },
    },
  },
  mounted() {
    this.$apollo.queries.getUserById.refetch()
    // this.$apollo.queries.getAllRoles.refetch()
  },
}
</script>
<style scoped>

</style>
